<template>
  <div class="right-box">
    <div class="right-header">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="crumbs">
        <el-breadcrumb-item v-for="(item,index) in navStr" 
        :key="item.id" 
        :to="index ===0?'/home/repositories?id='+item.id + '&name='+item.name+'&system=3':'/home/list?id='+navStr[0].id+'&cid='+item.id+'&name='+item.name+''">{{item.name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <span class="goBtn" @click="prev">返回</span>
    </div>
    <div class="right-box-content">
      <div class="left-list">
        <div class="detail-box">
          <div
            class="detial-title"
            v-if="fileNameHz === 'doc' || fileNameHz === 'docx'  || fileNameHz === 'xls' || fileNameHz === 'xlsx' || fileNameHz === 'ppt'|| fileNameHz === 'pptx' || fileNameHz === 'zip' || fileNameHz === 'rar'"
          >
            <a
              :href="'https://view.officeapps.live.com/op/view.aspx?src=' + fileDowns"
              target="_blank"
              style="color: #333333;display: flex"
            >
              <i
                class="iconfont iconfile_word"
                v-if="fileNameHz === 'doc' || fileNameHz === 'docx'"
              ></i>
              <i class="iconfont" v-if="fileNameHz === 'xls' || fileNameHz === 'xlsx'">
                <img src="../../assets/img/icon-file-xls.png" />
              </i>
              <i class="iconfont iconfile_ppt" v-if="fileNameHz === 'ppt' || fileNameHz === 'pptx'"></i>
              <i class="iconfont iconfile_zip" v-if="fileNameHz === 'rar' || fileNameHz === 'zip'"></i>
              <div style="display:inline-block;">
                <h3>{{fileName}}</h3>
                <p>
                  <span>{{upName}}</span>
                  <span>{{upTime}}</span>
                  <span>上次</span>
                  <span>{{fileSize}}K</span>
                </p>
              </div>
            </a>
          </div>
          <div
            class="detial-title"
            v-else-if="fileNameHz === 'pdf'"
            @click="showFile"
            style="cursor: pointer;"
          >
            <i class="iconfont iconfile_pdf"></i>
            <div style="display:inline-block;">
              <h3>{{fileName}}</h3>
              <p>
                <span>{{upName}}</span>
                <span>{{upTime}}</span>
                <span>上次</span>
                <span>{{fileSize}}K</span>
              </p>
            </div>
          </div>
          <div
            v-else-if="fileNameHz === 'png' || fileNameHz === 'jpg' || fileNameHz === 'jpeg' || fileNameHz === 'bmp' || fileNameHz === 'git' "
          >
            <img :src="fileDown" alt style="display:block;max-width: 100%;margin: 20px auto;" />
          </div>
          <div class="detial-title" v-else>
            <a
              :href="fileDown"
              target="_blank"
              style="color: #333333;display: flex"
            >
              <i class="iconfont iconfile_zip"></i>
              <div style="display:inline-block;">
                <h3>{{fileName}}</h3>
                <p>
                  <span>{{upName}}</span>
                  <span>{{upTime}}</span>
                  <span>上次</span>
                  <span>{{fileSize}}K</span>
                </p>
              </div>
            </a>
          </div>
<!--          <div v-if="fileNameHz === 'pdf'">-->
<!--            <iframe :src="fileDown" style="width: 100%;height: 500px;margin: 20px auto;border: 0;"></iframe>-->
<!--          </div>-->
          <ul>
            <li v-for="(item,index) in filelog" :key="index">
              <i class="iconfont iconshangchuan"></i>
              {{item.addtime}}
              <span style="padding: 0 10px;"></span>
              {{item.mnickname}}
              <span style="padding: 0 10px;"></span>上传了文件
            </li>
          </ul>
        </div>
      </div>
      <div class="right-set">
        <rightSet @isAdd="AddItem" :downStc="fileDown" :old="oldfile" />
      </div>
    </div>
  </div>
</template>

<script>
import rightSet from "./rightSetDetail";

export default {
  name: "detail",
  data() {
    return {
      navStr:[],
      navName: "", //  文件导航
      fileName: "", //  文件名
      fileNameHz: "", //  文件后缀
      upName: "", //  上传人姓名
      upTime: "", //  上传时间
      fileSize: "", //  文件大小
      fileDown: "", //  下载地址
      fileDowns:'',
      filelog: [], //  操作日志
      oldfile: [] //  旧版本
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    //  更新列表
    AddItem() {
      this.getDetail();
      this.$store.state.upTree = true;
    },
    NowTab() {
      this.$api.apiContent
        .NowTab({
          mid: this.$store.state.userMid,
          FileId: this.$route.query.cid
        })
        .then(res => {
          this.navName = "";
          this.navStr=[];
          var data = res.data;
          for(var i=0;i<data.length;i++){
            if (data[i].name){
                this.navStr.push(data[i])
                continue
            }
            this.navStr.push(
              {"name":data[i].label,"id":data[i].id}
            )
          }
        });
    },
    showFile() {
      console.log(this.fileDown);
      window.open(this.fileDown);
    },
    getDetail() {
      this.NowTab();
      this.$api.apiContent
        .getFileDetail({
          mid: this.$store.state.userMid,
          FileId: this.$route.query.cid
        })
        .then(res => {
          console.log(123)
          this.fileName = res.data.fileinfo.label; //  文件名
          this.fileNameHz = res.data.fileinfo.label.split(".").pop();
          this.upName = res.data.filelog.length>0?res.data.filelog[0].mnickname:''; //  上传人姓名
          this.upTime = this.$tools.ZHDate(
            new Date(res.data.fileinfo.addtime * 1000),
            8
          ); //  上传时间
          this.fileSize = (res.data.fileinfo.filesize / 1024).toFixed(1); //  文件大小
          this.fileDown = res.data.fileinfo.filepath; //  下载地址
          this.fileDowns = encodeURIComponent(res.data.fileinfo.filepath); //  下载地址
          this.filelog = res.data.filelog; //  操作日志
          this.filelog.map(item => {
            item.addtime = this.$tools.ZHDate(new Date(item.addtime * 1000), 1);
          });
          this.oldfile = res.data.oldfile;
          this.oldfile.map(item => {
            item.addtime = this.$tools.ZHDate(new Date(item.addtime * 1000), 1);
          });
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  watch: {
    $route: "getDetail"
  },
  components: {
    rightSet
  }
};
</script>

<style scoped lang="scss">
.goBtn {
  height: 42px;
  line-height: 42px;
  width: 60px;
  text-align: center;

  border-radius: 6px;
  cursor: pointer;
  background: #0a2240;
  color: #ffffff;
}
.crumbs{
  font-size: 18px;
}
.right-box {
  .right-header {
    height: 60px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    b {
      font-size: 18px;
      padding-right: 5px;
    }
  }

  .right-box-content {
    display: flex;

    .left-list {
      flex: 1;

      .detail-box {
        width: 60%;
        margin: 40px auto;

        .detial-title {
          display: flex;
          align-items: center;
          padding: 30px;
          border-bottom: 1px solid #ddd;

          i {
            font-size: 60px;
            color: #0a2240;
          }

          div {
            padding: 0 20px;

            h3 {
              line-height: 40px;
              font-size: 20px;
            }

            p {
              line-height: 20px;
              color: #999;

              span {
                padding-right: 10px;
              }
            }
          }
        }

        ul {
          padding: 30px;

          li {
            line-height: 40px;
            color: #666;

            i {
              display: inline-block;
              width: 30px;
              height: 30px;
              text-align: center;
              line-height: 30px;
              padding: 0;
              color: #fff;
              margin-right: 5px;
              background: #999;
              border-radius: 100%;
            }
          }
        }
      }
    }

    .right-set {
      width: 250px;
      padding: 25px;
      height: calc(100vh - 160px);
      background: #edf2f7;
    }
  }
}
</style>